export default __webpack_public_path__ + "static/media/ashleiDraenorMap.4373a16f.jpg";